import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseService, EntityWithPassword} from 'public-shared/services/base-http/base.service';
import {Observable} from 'rxjs';
import {TenantGenericKeysEndpoints} from 'shared/services/endpoint-constants';
import {IGenericKeyEntity, ITenantGenericKeys} from './j4-tenants-generic-keys.dto';
import {IREAUTHENTICATIONDTO} from '../merchant/merchant.service';

@Injectable()
export class J4TenantsGenericKeysService extends BaseService {
  /**
   * Set base url
   */
  constructor(protected override http: HttpClient) {
    super(http);
  }

  public addGenericKeys$(keys: IGenericKeyEntity, reauthenticationDto: IREAUTHENTICATIONDTO): Observable<void> {
    const {password, passCode, reason, classification, stepUpToken, reauthenticationMethod} = reauthenticationDto;

    return this.post$<void>(
      TenantGenericKeysEndpoints.MULTIPLE_SETTINGS,
      new EntityWithPassword(keys, password, passCode, reason, classification, stepUpToken, reauthenticationMethod)
    );
  }

  public getGenericKeys$(): Observable<Array<ITenantGenericKeys>> {
    return this.get$<Array<ITenantGenericKeys>>(TenantGenericKeysEndpoints.GENERIC_KEYS);
  }
}
